import { ListBulletIcon, TokensIcon } from '@radix-ui/react-icons';
import { cn } from '@/lib/utils';
import {
  PhotoCarouselAdminView,
  parsePhotoCarouselAdminView,
} from './adminViewPreference';
import {
  PhotoSubmissionFilter,
  PhotoSubmissionStatus,
} from './submissionStatus';

const FILTERS: { id: PhotoSubmissionFilter; label: string }[] = [
  { id: 'all', label: 'All' },
  { id: 'pending', label: 'Pending' },
  { id: 'approved', label: 'Approved' },
  { id: 'rejected', label: 'Rejected' },
];

export function PhotoCarouselViewToggle({
  value,
  onChange,
  iconOnly,
}: {
  value: PhotoCarouselAdminView;
  onChange: (value: PhotoCarouselAdminView) => void;
  iconOnly?: boolean;
}) {
  return (
    <div
      data-name="PHOTO_CAROUSEL_VIEW_TOGGLE"
      className="inline-flex h-8 items-center rounded-md border border-border p-[3px]"
    >
      {(['cards', 'list'] as const).map((option) => (
        <button
          key={option}
          type="button"
          aria-label={option === 'cards' ? 'Cards view' : 'List view'}
          aria-pressed={value === option}
          className={cn(
            'inline-flex h-[26px] items-center justify-center gap-1.5 rounded px-2 text-xs font-medium text-muted-foreground',
            value === option && 'bg-secondary text-foreground',
          )}
          onClick={() => onChange(parsePhotoCarouselAdminView(option))}
        >
          {option === 'cards' ? (
            <TokensIcon className="h-3.5 w-3.5" />
          ) : (
            <ListBulletIcon className="h-3.5 w-3.5" />
          )}
          <span className={cn(iconOnly ? 'sr-only' : 'hidden sm:inline')}>
            {option === 'cards' ? 'Cards' : 'List'}
          </span>
        </button>
      ))}
    </div>
  );
}

export function PhotoCarouselStatusTabs({
  value,
  onChange,
  counts,
}: {
  value: PhotoSubmissionFilter;
  onChange: (value: PhotoSubmissionFilter) => void;
  counts: Record<PhotoSubmissionStatus, number> & { all: number };
}) {
  return (
    <div
      data-name="PHOTO_CAROUSEL_STATUS_TABS"
      className="-mb-px flex min-w-0 flex-1 items-end gap-1 overflow-x-auto"
    >
      {FILTERS.map((filter) => {
        const active = value === filter.id;
        return (
          <button
            key={filter.id}
            type="button"
            className={cn(
              'relative shrink-0 px-2 pb-2 text-[13px] font-medium text-muted-foreground md:text-sm',
              active && 'text-foreground',
            )}
            onClick={() => onChange(filter.id)}
          >
            {filter.label}
            <span
              className={cn(
                'ml-1.5 inline-flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-[11px] font-semibold',
                active
                  ? 'bg-epic text-epic-foreground'
                  : 'bg-muted text-muted-foreground',
              )}
            >
              {counts[filter.id]}
            </span>
            {active && (
              <span className="absolute inset-x-1 bottom-0 h-0.5 rounded-full bg-epic" />
            )}
          </button>
        );
      })}
    </div>
  );
}
